import {FC, useEffect, useMemo, useState} from "react";
import {Document} from "./Document/Document";
import styles from "./Table.module.sass";
import cn from "classnames";
import {useAppDispatch, useAppSelector} from "toolkit/hooks";
import {useParams} from "react-router-dom";
import {getDocumentList} from "toolkit/documents/folders/folders.thunks";
import {NoData} from "components-new/NoData/NoData";
import {ChangeSearchValue} from "toolkit/documents/documents.slice";

interface TableProps {
	targetId?: number;
}

export const Table: FC<TableProps> = ({ targetId }) => {
	const dispatch = useAppDispatch();
	const { documentList, versionMode, versionList } = useAppSelector((state) => state.folders);
	const { searchValue } = useAppSelector((state) => state.documents);
	const [showVersions, setShowVersions] = useState<boolean>(false);
	const { folderId, condition } = useParams();

	useEffect(() => {
		if (!versionMode)
			dispatch(
				getDocumentList({
					folderId: Number(folderId),
					archived: condition === "archive",
				}),
			);
		//eslint-disable-next-line
	}, [folderId, condition]);

	useEffect(() => {
		if (versionMode) {
			setShowVersions(true);
		} else {
			setShowVersions(false);
		}

		return () => {
			dispatch(ChangeSearchValue(""));
		};
		//eslint-disable-next-line
	}, []);

	const filterList = useMemo((): any[] => {
		return documentList.filter((document) =>
			document.name.toLowerCase().includes(searchValue.trim().toLowerCase()),
		);
		//eslint-disable-next-line
	}, [searchValue]);

	return (
		<>
			<table className={cn(styles["table-head"])}>
				<thead className={styles.head}>
					<tr>
						<th>Название документа</th>
						<th>Загрузил</th>
						<th>Дата загрузки</th>
					</tr>
				</thead>
			</table>
			{documentList.length ? (
				<div data-comment-false={true} className={styles["table-body-wrp"]}>
					<table className={styles["table-body"]}>
						<tbody className={styles.body}>
							{showVersions &&
								versionList.map((document) => (
									<Document targetId={targetId} key={document.id} document={document} flag={true} />
								))}
							{!showVersions &&
								(searchValue.trim() ? (
									filterList.length ? (
										filterList.map((document) => <Document key={document.id} document={document} />)
									) : (
										<NoData title="Ничего не найдено" />
									)
								) : (
									documentList.map((document) => <Document key={document.id} document={document} />)
								))}
						</tbody>
					</table>
				</div>
			) : (
				<NoData title="Данные отсутствуют" />
			)}
		</>
	);
};
